<template>
  <v-app id="app">
    <AppBar v-if="token && isShowAppBar" :token="token" :nt_code="nt_code" />
    <v-content :class="margin">
      <div v-if="loading" class="text-center">
        <h3>
          <v-progress-circular
            :size="70"
            :width="7"
            class="mr-1"
            indeterminate
            color="primary"
          ></v-progress-circular>
          Loading...
        </h3>
      </div>
      <router-view v-else></router-view>
    </v-content>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar';
import axios from '@/axios';
import axios_auth from '@/axios_auth';
import EventBus from '@/EventBus';

export default {
  name: 'App',
  components: {
    AppBar
  },
  data() {
    return {
      token: '',
      margin: '',
      nt_code: '',
      loading: false,
      isShowAppBar: false
    };
  },
  async created() {
    window.location.href = 'https://parcel-int-mweb-prod.lpp.co.th/';
    return;
    // return this.logout()
    this.setAuthHeader();

    EventBus.$on('setToken', (params) => {
      console.log('setToken');
      this.token = params.token;
    });

    EventBus.$on('setNtCode', (params) => {
      console.log('setNtCode');
      this.nt_code = params.nt_code;
    });

    EventBus.$on('resetToken', (params) => {
      console.log('resetToken');
      this.token = '';
    });
  },
  watch: {
    token() {
      if (this.token) {
        axios.defaults.headers.common['Authorization'] = this.token;
        this.margin = 'mt-11';
      } else {
        delete axios.defaults.headers.common['Authorization'];
      }
    }
  },
  async mounted() {
    // return this.logout()
    if (
      this.$route.query &&
      this.$route.query.username &&
      this.$route.query.token
    ) {
      // console.log('key', this.$route.query.username)
      this.loading = true;
      await this.doAuthenByKey();
    }

    if (
      this.$router.currentRoute.name == 'ot-parcel/:lineID/:channelID' ||
      this.$router.currentRoute.name == 'cus-receive/:id'
    ) {
      return true;
    } else {
      let localitem = this.getLocalItem();
      if (!localitem && this.$router.currentRoute.name == 'login') {
        return true;
      } else if (!localitem) {
        return this.$router.replace({ name: 'login' });
      }

      if (this.$route.query.routeName == 'import') {
        this.isShowAppBar = false;
      } else if (!localitem.nt_code) {
        this.isShowAppBar = true;
        this.token = localitem.token;
        return this.$router.replace({ name: 'project' });
      }
      if (localitem.availableUntil) {
        if (
          this.$moment().diff(
            this.$moment(localitem.availOPEN_DATEableUntil, 'MM/DD/YYYY H:i:s'),
            'second'
          ) > 0
        ) {
          return this.logout();
        }
      }
      this.token = localitem.token;
    }
    this.refreshToken().then((res) => {
      console.log('refreshToken');
      let localitem = this.getLocalItem();

      localitem.refreshToken = res.refreshToken;
      localitem.token = res.jwt;
      localitem.availableUntil = res.availableUntil;

      localStorage.setItem('parcel', JSON.stringify(localitem));
    });
  },
  methods: {
    async doAuthenByKey() {
      let username = this.$route.query.username;
      let system_key = 'D468BC5B9E0F45158D2B329E08D6FA7B';
      let system = 'parcel-receive';
      let formData = {
        username,
        system_key,
        system
      };
      console.log('doAuthenByKey', username);

      try {
        await axios_auth
          .post('/AuthenticationByKey', JSON.stringify(formData))
          .then((res) => {
            console.log('AuthenticationByKey', res.data);
            if (res.data.status === '1') {
              //set user token to localStorage
              let auth_data = {
                refreshToken: res.data.refreshToken,
                token: res.data.jwt,
                user_id: username
              };
              localStorage.setItem('parcel', JSON.stringify(auth_data));
            }
          })
          .then(() => {
            this.refreshToken().then((res) => {
              let auth_data = {
                refreshToken: res.refreshToken,
                token: res.jwt,
                user_id: username,
                availableUntil: res.availableUntil
              };
              localStorage.setItem('parcel', JSON.stringify(auth_data));

              EventBus.$emit('setToken', { token: res.jwt });

              this.loading = false;
              // this.$router.replace({name: 'project'})
              // this.logout()
            });
          })
          .catch((err) => {
            if (err.response) {
              this.error.status = err.response.data.status;
              this.error.error_code = err.response.status;
              if (err.response.status === 401) {
                this.error.msg = 'ชื่อผู้ใช้งาน หรือ รหัสผ่านไม่ถูกต้อง';
              } else {
                this.error.msg = err.response.data.msg;
              }

              console.log(this.error);
            }
          });
      } catch (err2) {
        console.log(err2.message);
      }
    }
  }
};
</script>
